import useLanguage from "./useLanguage";

type Options = { decimals?: number };

export const useFormatNumber = () => {
  const { language } = useLanguage();

  return (value: number, options: Options = {}) =>
    new Intl.NumberFormat(language, {
      minimumFractionDigits: options.decimals ?? 0,
      maximumFractionDigits: options.decimals ?? 0,
    }).format(value);
};
